export default __webpack_public_path__ + "static/neckband_m-e09368d255468f28ea5740e454c950bf.png";